// BREADCRUMBS FUNCTION RETURN ENTITIES IN SPANISH
export const entityTraducLibrary = (entity = "") => {
  switch (entity) {
    case "organizations":
      return "organizaciones"
    case "users":
      return "usuarios"
    case "subscribers":
      return "suscriptores"
    case "subscriber":
      return "suscriptores"
    case "suborganizations":
      return "estudios"
    case "suscriptions":
      return "suscripciones"
    case "recycle":
      return "papelera interna"
    case "storage":
      return "almacenamiento"
    case "applicationInstances":
      return "instancia de aplicación"
    case "instance":
      return "instancias"
    case "globalNotification":
      return "Notificaciones globales"
    case "statusStorage":
      return "estructura de almacenamiento"
    case "statusME":
      return "estado de inicialización"
    case "feacture-flags":
      return "control de versiones"
    case "add":
      return "Agregar nueva notificación"
    case "edit":
      return "Editar notificación"
    case "declarations":
      return "declaraciones"
    case "eventanilla":
      return "e-Ventanilla"
    case "loadedClients":
      return "CUITs aceptados en ARCA"
    default:
      return entity
  }
}
